import type { KioskSessionView } from '@print-saas/shared';
import { CheckIcon } from '../components/icons';
import { MessageScreen } from '../components/MessageScreen';
import { plural } from '../lib/format';

export function CompletedScreen({ session }: { session: KioskSessionView }) {
  return (
    <MessageScreen
      tone="go"
      icon={<CheckIcon />}
      title="Please collect your prints"
      subtitle={`${plural(session.totalSheets, 'sheet')} printed. Thank you — see you again!`}
    >
      <div className="animate-bob text-[14vmin] leading-none" role="img" aria-label="Collect below">
        👇
      </div>
    </MessageScreen>
  );
}
